import React from "react";
import { Button } from "usebeauty";
import { useRoutes } from "@router/Router";
import { ChevronLeft, Close } from "@Icons";
import "./OnBoardPage.scss";

const OnBoardPage = () => {
  const { step, navigate } = useRoutes();
  return (
    <div className="alchera-demo-onboard">
      <div className="navigation">
        {step.prev && (
          <i onClick={() => navigate("prev")}>
            <Close st={{ fontSize: "16px" }} />
          </i>
        )}
      </div>
      <div className="container">
        <div className="title">
          <p>
            <b>비대면 실명확인</b>을 위한
          </p>
          <p>
            <b>신원 확인 AI 솔루션</b>을
          </p>
          <p>직접 경험해 보세요!</p>
        </div>
        <div className="steps">
          <div className="step">
            <h5>STEP 1</h5>
            <span>신분증 OCR</span>
          </div>
          <div className="next">
            <ChevronLeft st={{ color: "#ddd", fontSize: "20px", transform: "rotate(90deg)" }} />
          </div>
          <div className="step">
            <h5>STEP 2</h5>
            <span>신분증 사본판별</span>
          </div>
          <div className="next">
            <ChevronLeft st={{ color: "#ddd", fontSize: "20px", transform: "rotate(90deg)" }} />
          </div>
          <div className="step">
            <h5>STEP 3</h5>
            <span>얼굴 라이브니스</span>
          </div>
          <div className="next">
            <ChevronLeft st={{ color: "#ddd", fontSize: "20px", transform: "rotate(90deg)" }} />
          </div>
          <div className="step">
            <h5>STEP 4</h5>
            <span>얼굴 매칭</span>
          </div>
        </div>
        <div className="information">
          <h5>데모 안내</h5>
          <ul>
            <li>데모 URL은 발급일로부터 15일 이후에는 사용이 불가합니다.</li>
            <li>데이터 통신이 원활한 환경에서 사용해 주시기 바랍니다.</li>
            <li>카메라 성능에 따라 결과값이 달라질 수 있습니다.</li>
            <li>개인정보는 데모 체험 후 파기됩니다.</li>
            <li>Web으로 구현된 데모로 일부 기능이 제한될 수 있습니다.</li>
          </ul>
        </div>
      </div>
      <Button onClick={() => navigate("next")}>
        <span>시작하기</span>
        <ChevronLeft st={{ fontSize: "20px" }} />
      </Button>
    </div>
  );
};

export default OnBoardPage;
